import '.a{display:flex;}.ssr-plugin'
import '.i{justify-content:center;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.aj{gap:0.5rem;}.ssr-plugin'
import '.ap{cursor:pointer;}.ssr-plugin'
import '.h7{padding:0.75rem;}.ssr-plugin'
import '.ad{border-radius:1.25rem;}.ssr-plugin'
import '.ak{border:var(--blue-border);}.ssr-plugin'
import '.ae{background-color:var(--shades-white);}.ssr-plugin'
import '.dz{transition:background-color 0.2s ease;}.ssr-plugin'
import '.d5{width:2.5rem;}.ssr-plugin'
import '.d6{height:2.5rem;}.ssr-plugin'
import '.h8{color:var(--shades-blue-700);}.ssr-plugin'
import '.h9{font-size:0.9rem;}.ssr-plugin'
import '.az{font-weight:400;}.ssr-plugin'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'inlines'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { MouseEventHandler } from 'react'

export type SocialMediaButtonProps = {
  icon: IconProp
  label: string
  onClick: MouseEventHandler<HTMLButtonElement>
  isMobile?: boolean
}

export const SocialMediaButton = ({
  icon,
  label,
  onClick,
  isMobile,
}: SocialMediaButtonProps) => {
    return (
      <styled.button className="a i b c aj ap h7 ad ak ae dz"
        style={{
          '&:hover': {
            backgroundColor: 'var(--shades-blue-50)',
          },
          width: isMobile ? '8rem' : '5.5rem',
          height: isMobile ? '8rem' : '5.5rem',
        }}
        onClick={onClick}
      >
        <div className="d5 d6 a c i h8"
          style={{
            fontSize: isMobile ? '3rem' : '2rem',
          }}
        >
          <FontAwesomeIcon icon={icon} />
        </div>
        <span className="h9 h8 az"
        >
          {label}
        </span>
      </styled.button>
    )
}